export default __webpack_public_path__ + "static/media/levelthreeaudit.9e21b7a2.png";